<template>
  <div>
    <b-card v-if="friendshipsPending.totalCount > 0">
      <b-pagination
        align="center"
        size="md"
        :total-rows="friendshipsPending.totalCount"
        v-model="currentPage"
        :per-page="nbUserPerPage"
        @change="onPageChange"
      ></b-pagination>
      <b-list-group>
        <b-list-group-item
          v-for="friendship in friendshipsPending.data"
          :key="friendship.id"
          v-if="friendship.accepted === false && friendship.fromUser && friendship.toUser"
          class="container-fluid pull-right mb-2"
        >
          <a
            :href="`/profile/${user.id === friendship.fromUser._id ? friendship.toUser._id : friendship.fromUser._id}`"
            class="pull-left"
          >
            <img
              :src="user.id === friendship.fromUser._id ? friendship.toUser.picture : friendship.fromUser.picture"
              alt="Photo de profil"
              width="42"
              height="42"
              class="rounded-circle m-2"
            >
            {{ user.id === friendship.fromUser._id ? friendship.toUser.username : friendship.fromUser.username }} ({{ user.id === friendship.fromUser._id ? friendship.toUser.firstname : friendship.fromUser.firstname }} {{ user.id === friendship.fromUser._id ? friendship.toUser.lastname : friendship.fromUser.lastname }} {{ user.id === friendship.fromUser._id ? friendship.toUser.email : friendship.fromUser.email }})
          </a>
          <b-button
            class="pull-right m-2 p-2"
            variant="danger"
            size="md"
            title="Supprimer la relation"
            v-confirm="{
                      loader: true,
                      okText: 'Confirmer',
                      cancelText: 'Annuler',
                      ok: dialog => onDeleteFriendship(dialog, friendship._id),
                      message: user.id === friendship.fromUser._id ? 'Souhaitez-vous vraiment annuler cette demande?' : 'Souhaitez-vous vraiment décliner cette demande?'
                    }"
          >
            {{ user.id === friendship.fromUser._id ? 'Annuler la demande' : 'Décliner la demande' }}
            <i
              class="fa fa-times fa-fw"
            ></i>
          </b-button>
          <b-button
            v-if="user.id === friendship.toUser._id"
            class="pull-right m-2 p-2"
            variant="primary"
            size="md"
            @click="onConfirmFriendship(friendship._id)"
          >
            Accepter la demande
            <i class="fa fa-eye fa-fw"></i>
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <b-pagination
        align="center"
        size="md"
        :total-rows="friendshipsPending.totalCount"
        v-model="currentPage"
        :per-page="nbUserPerPage"
        @change="onPageChange"
      ></b-pagination>
    </b-card>
    <b-card v-if="friendshipsPending.totalCount === 0">Aucune demande d'ami en attente</b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PendingFriends",
  data: function() {
    return {
      currentPage: 1,
      nbUserPerPage: 5
    };
  },
  mounted: function() {
    this.getAllPending({
      userId: this.user.id,
      accepted: false,
      page: this.currentPage,
      limit: this.nbUserPerPage,
      sort: "username"
    });
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState("friendship", ["friendshipsPending", "status"])
  },
  watch: {
    status: function(newVal) {
      if (newVal.deleted || newVal.updated) {
        this.getAllPending({
          userId: this.user.id,
          accepted: false,
          page: this.currentPage,
          limit: this.nbUserPerPage,
          sort: "username"
        });
      }
    }
  },
  methods: {
    ...mapActions("friendship", ["getAllPending", "update", "destroy"]),
    onPageChange(page) {
      this.currentPage = page;
      this.getAllPending({
        userId: this.user.id,
        accepted: false,
        page: page,
        limit: this.nbUserPerPage,
        sort: "username"
      });
    },
    onConfirmFriendship(id) {
      this.update(id);
    },
    onDeleteFriendship(dialog, id) {
      this.destroy(id).then(() => dialog.close());
    }
  }
};
</script>
